import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { baseUrl } from "../constant.js";

const Wallethistory = () => {
  const [data, setData] = useState("");
  // console.log(data)
  useEffect(() => {
    getdata();
  }, []);
  const getdata = async () => {
    const Token = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("Token", Token);

    const result = await axios.post(
      baseUrl + `authController/getWalletHistory`,
      formData,
    );
    setData(result.data);
  };
  return (
    <>
      <section className="online_trade_view">
        <div className="text-center">
          <div className="onine_view_col">
            <div className="phone_frame">
              <div className="frame_screen">
                <div className="screen_body p-0">
                  <div className="dashboard_main">
                    <div className="dashboard_header">
                      <div>
                        <Link to="/seeting">
                          <i className="fa fa-angle-left"></i>
                        </Link>
                      </div>
                      <div>
                        <h4> My E-Wallet</h4>
                      </div>
                      <div>
                        <div className="ui_dropdown">
                          <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="fa fa-ellipsis-v"></i>
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href="edit-profile.html"
                              >
                                My Profile
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Logout
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="market_tab_col">
                      <div className="tab-content dashboard_col_tabs">
                        {data
                          ? data.data.map((item) => (
                              <div className="market_trades_colm wallet_history_tab">
                                <div className="history_tab_list">
                                  <ul>
                                    <li>{item.description}</li>
                                    <li>
                                      Before Point -{" "}
                                      <span>
                                        <i className="fa fa-indian-rupee-sign"></i>
                                        {item.before_point}
                                      </span>
                                    </li>
                                    <li>
                                      After Point -{" "}
                                      <span>
                                        <i className="fa fa-indian-rupee-sign"></i>
                                        {item.after_point}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                                <div>
                                  <h3>
                                    <i className="fa fa-indian-rupee-sign"></i>
                                    <span>{item.affect_point}</span>
                                  </h3>
                                  <h5>{item.created}</h5>
                                </div>
                              </div>
                            ))
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Wallethistory;
